import Component from './Component';
import QuickStart from './QuickStart';
import axios from 'axios';
import { togglePreloader } from './../services/ScrollResizeHandler';
import { renderProjectTemp, noResultsTemp } from './../services/Templates';
import { filterArray } from './../utilities/filter_array';

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */
 let newPromise;
 let mapping = new Map();
 let nextURL;
 let quickStartModule;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */






/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class ProjectList extends Component {

    decorator () {
        return {
            selector : '.js-project-list',
            name : 'ProjectList',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();

        this.bindElements();

        // INITITAL LOAD OF MODULE
        this.renderModule(this.tile[3]);
    }


    cacheElements () {
        this.button = this.element.querySelector('.js-button');
        this.container = this.element.querySelector('.js-project-list-container');
        this.tile = Array.from(this.container.querySelectorAll('.c-pp-tile'));
        this.quickstart = this.element.getAttribute('data-quickstart');
    }


    bindElements () {
        let num = 2;

        // LOAD MORE BUTTON
        this.button.addEventListener('click', e => {
            e.preventDefault();

            togglePreloader();

            setTimeout(() => {
                this.loadProjects(num, false);
                if (nextURL != null || !nextURL) { num++; }
            }, 350);
        });
    }

    // FILTER PROJECTS
    filterProject (type, object = {}) {
        const val = Array.from(object);
        const URL = val[1] ? `type=${val[0][0]}&value=${val[0][1]}&type2=${val[1][0]}&value2=${val[1][1]}` : `type=${val[0][0]}&value=${val[0][1]}`;

        newPromise = axios.get(`/api/article-list/filter/${type}?${URL}`)
            .then(response => {
                return response.data;
            })
            .then(data => {
                const projectData = data.data;
                let appendMarkUp;

                this.container.innerHTML = '';

                for (let i = 0; i < projectData.length; i++) {
                    appendMarkUp = renderProjectTemp(projectData[i]);
                    this.container.insertAdjacentHTML('beforeend', appendMarkUp);
                }

                return data;
            })
            .then(data => {
                togglePreloader();

                if (data.next_page_url == null) {
                    this.container.classList.remove('has-load-more');
                    this.button.parentElement.classList.add('is-hidden');
                } else {
                    this.container.classList.add('has-load-more');
                    this.button.parentElement.classList.remove('is-hidden');
                }

                nextURL = data.next_page_url;

                return data;
            })
            // filter dropdown list
            .then(data => {
                if (data.data.length < 1) {
                    this.container.innerHTML = '';
                    this.container.insertAdjacentHTML('beforeend', noResultsTemp('Your filter returned no results.', 'Try changing your filters.'));
                }

                return data;
            })
            .then(data => {
                const renderedTile = Array.from(this.container.querySelectorAll('.c-pp-tile'));

                if (renderedTile.length < 1) { return; }

                const num = renderedTile.length > 4 ? 3 : renderedTile.length - 1;

                this.renderModule(renderedTile[num]);
            })
            .catch(error => {
                console.error(error);
            })
    }



    // LOAD PROJECTS
    loadProjects (num = 2, init = true) {
        const URL = nextURL ? nextURL : `/api/article-list/projects?page=${num}`;

        newPromise = axios.get(URL)
            .then(response => {
                return response.data;
            })
            .then(data => {
                const projectData = data.data;
                let appendMarkUp;

                for (let i = 0; i < projectData.length; i++) {
                    appendMarkUp = renderProjectTemp(projectData[i]);
                    this.container.insertAdjacentHTML('beforeend', appendMarkUp);
                }

                return data;
            })
            .then(data => {
                togglePreloader();

                if (data.next_page_url == null) {
                    this.container.classList.remove('has-load-more');
                    this.button.parentElement.classList.add('is-hidden');
                } else {
                    this.container.classList.add('has-load-more');
                    this.button.parentElement.classList.remove('is-hidden');
                }

                nextURL = data.next_page_url;

                return data;
            })
            .then(data => {
                if (!init) { return; }

                const renderedTile = Array.from(this.container.querySelectorAll('.c-pp-tile'));

                if (renderedTile.length < 1) { return; }

                const num = renderedTile.length > 4 ? 3 : renderedTile.length - 1;

                this.renderModule(renderedTile[num]);
            })
            .catch(error => {
                console.error(error);
            });
    }



    // RENDER QUICKSTART MODULE
    renderModule (tile) {

        if (parseInt(this.quickstart) == 0) { return; }

        const modulePromise = axios.get('/quickstart/template')
            .then(response => {
                return response.data;
            })
            .then(data => {
                const quickStart = $.parseHTML(data)[0];
                tile.parentNode.insertBefore(quickStart, tile.nextSibling);
                return data;
            })
            .then(data => {
                this.quickstart = this.container.querySelector('.js-quick-start');
                quickStartModule = QuickStart.bindElement(this.quickstart);
            })
            .catch(error => {
                console.error(error);
            })
    }



    // DISABLE FILTER ITEMS
    disableFilterItems (dropdown, data) {
        const myDropdown = Array.from(dropdown[0].querySelectorAll('option'));

        // remove all disabled attribute
        myDropdown.forEach(item => {
            item.removeAttribute('disabled');
        });


        if (data) {
            const filteredArray = filterArray(myDropdown, data);

            filteredArray.forEach(item => {
                if (item.value != dropdown.val() && item.value != '') {
                    item.setAttribute('disabled', '')
                }
            });
        }


        dropdown.select2('destroy')
            .select2({
                dropdownParent: dropdown.parent()
            });
    }

}
